import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ViewBasePage } from '@shared/pages';
import { RoutesService, ShuttlesService } from '@shared/services';
import { RadioModalPage } from '@shared/pages';
import type { TDistinctColorInfo, TResponse, TShuttle } from '@shared/models';

@Component({
    'selector': 'app-shuttle',
    'templateUrl': './shuttle.page.html',
    'styleUrls': ['./shuttle.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class ShuttlePage extends ViewBasePage implements OnInit, OnDestroy {
    public isDebugMode = false;
    public shuttle: TShuttle;
    public saveAttempt = false;
    public submitted = false;

    constructor(private shuttlesService: ShuttlesService, private activatedRoute: ActivatedRoute,
        private routesService: RoutesService,  injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_SHUTTLE);
    }

    public override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        this.shuttle = this.shuttlesService.getNullableShuttle();
        this.isDebugMode = this.sessionService.isDebugMode();

        try {
            const uid = this.activatedRoute.snapshot.paramMap.get('uid');
            if (uid) {
                this.uxHelperService.showSpinner();
                this.shuttle = await this.shuttlesService.getByUid(uid);
                this.uxHelperService.hideSpinner();
            } else {
                this.shuttle = this.shuttlesService.getNullableShuttle();
                this.shuttle.status = 'Idle';
                this.shuttle.passengerCapacity = 1;
            }
            // this.initMoreMenu();
        } catch (err) {
            throw new Error('Error in shuttle.ngOnInit() ');
        }
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    // public initMoreMenu(): void {
    //     this.resetPopoverMenu();
    //     this.pushPopoverMenuItem('Show Tour', 'show-shuttle-tour');
    // }

    // public onColorClick(): void {
    //     const colors = ['Black', 'Blue', 'Red', 'Silver', 'White'];
    //     this.uxHelperService.showRadioAlert('Select Shuttle Color', colors, this.shuttle.color, (response) => {
    //         this.shuttle.color = response.selection;
    //     });
    // }

    // public onStatusClick(): void {
    //     const items = ['Idle', 'Assigned', 'Traveling'];
    //     this.uxHelperService.showRadioAlert('Select Shuttle Status', items, this.shuttle.status, async (response) => {
    //         if (response.selection) {
    //             this.shuttle.status = response.selection;
    //             if (this.shuttle.uid) {
    //                 const route = await this.routesService.getByUid(this.shuttle.uid);
    //                 if (route) {
    //                     route.shuttle.status = response.selection;
    //                     await this.routesService.update(route);
    //                 }
    //             }
    //         }
    //     });
    // }

    public async onStatusClick(): Promise<void> {
        // const setNames = this.incentiveSets.map(item => item.setName);
        const items = ['Idle', 'Assigned', 'Traveling'];

        const options: any = {
            'component': RadioModalPage,
            'componentProps': { 'items': items, 'title': 'Select Shuttle Status' },
            'backdropDismiss': false,
            'showBackdrop': true,
            'cssClass': 'shuttleRadioModal'
        };

        const myModal = await this.modalController.create(options);
        await myModal.present();
        const response: any = await myModal.onDidDismiss();
        // const response: any = await myModal.onDidDismiss();

        if (response.okay) {
            this.shuttle.status = response.selectedItems[0];
            if (this.shuttle.uid) {
                const route = await this.routesService.getByUid(this.shuttle.uid);
                if (route) {
                    route.shuttle.status = response.selectedItems[0];
                    await this.routesService.update(route);
                }
            }
        }

        // this.selectedIncentiveSet = this.incentiveSets.find(incentive => {
        //     return (incentive.setName === response.data.selectedItem);
        // });
        // }
    }

    // public onColorClick(): void {
    // const colors = ['Black', 'Blue', 'Red', 'Silver', 'White'];
    // this.uxHelperService.showRadioAlert('Select Shuttle Color', colors, this.shuttle.color, (response) => {
    //     this.shuttle.color = response.selection;
    // });
    // }

    public async onSaveClick(form: NgForm) {
        this.submitted = true;
        if (!form.valid) {
            return;
        }

        // Ionic is returning a string even though the type is a number - Convert to number.
        this.shuttle.passengerCapacity *= 1;

        try {
            await this.uxHelperService.showSpinner('Saving.  Please wait...');
            const isUnique = await this.shuttlesService.isShuttleNameUnique(this.shuttle);
            if (!isUnique) {
                await this.uxHelperService.showAlert('Error:', 'This shuttle name is already being used.');
                return;
            }

            // I don't know how, but two shuttles ended up with the same color.
            // So, make certain that the color that is being assigned is not being used by another shuttle. 
            const shuttles = await this.shuttlesService.getAll();
            const numShuttlesUsingThisColor = shuttles.filter(shuttle => shuttle.color === this.shuttle.color).length;
            if (numShuttlesUsingThisColor > 1) {
                const usedColors = shuttles.map(shuttle => shuttle.color);
                const colorInfo: TDistinctColorInfo = this.utilsService.findUniqueColor(usedColors);
                this.shuttle.color = colorInfo.name;
            }

            // const numShuttles = await this.shuttlesService.size();
            // const colorInfo: TDistinctColorInfo = this.utilsService.getColorInfo(numShuttles);

            await this.shuttlesService.save(this.shuttle);

            // There is a one-to-one relationship between the shuttle and the vector.
            // So create the associated vector now.
            this.uxHelperService.showToast('Saved.');
            this.router.navigateByUrl(`/managerSettings/shuttles`);
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            await this.uxHelperService.showAlert('Error:', errorMessage);
        } finally {
            await this.uxHelperService.hideSpinner();
        }
    }
}
